import React, { useState, useEffect } from 'react';
import logosm from '../assets/logosm.png'

const Header = () => {
  const [header, setHeader] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.scrollY > 50 ? setHeader(true) : setHeader(false);
    });
  });


  return (
    <header className={`${header ? 'bg-white py-2 shadow-lg' : 'bg-transparent py-2'} fixed z-50 transition-all w-full duration-500`}>
      
      <div className='container mx-auto flex flex-col items-center gap-y-6 lg:flex-row lg:justify-between lg:gap-y-0 md:flex-row md:justify-between'>

        <a href='/'>
          <img className='w-[80px]' src={logosm} alt='Logo'/>
        </a>

      
        <nav className={`${header ? 'text-blue-800' : 'text-white'} flex gap-x-5 md:gap-x-8 lg:gap-x-12
          text-[15px] md:text-[18px] lg:text-[22px] font-bold items-center font-primary`}>

          <a href='#contactUs' className=' hover:text-pink-600 transition font-primary' onClick={() => window.scroll(0,5550)}>
            تماس با ما
          </a>

          <a href='#aboutUS' className=' hover:text-pink-600 transition font-primary' onClick={() => window.scroll(0,4500)}>
            درباره ما
          </a>

          <a href='#products' className=' hover:text-pink-600 transition font-primary' onClick={() => window.scroll(0,550)}>
            محصولات
          </a>
          
          <a href='/' className=' hover:text-pink-600 transition font-primary'>
            خانه
          </a>


        </nav>
       
      </div>
    </header>
  )
};

export default Header;